/**
 * 计算文字宽度
 * @private
 * @param {string} text
 * @returns {number}
 */
export function _measureTextWidth (text) {
  let span = document.createElement('span');
  span.innerText = text;
  span.style.opacity = 0;
  document.body.appendChild(span);
  const w = span.getBoundingClientRect().width;
  document.body.removeChild(span);
  span = null;
  return Math.ceil(w);
}

/**
 * 取得形如 100px 的属性
 * @param {HTMLElement} ele
 * @param {string} styleName
 * @returns {number}
 */
export function _getPxStyle (ele, styleName) {
  if (!window.getComputedStyle) return null;
  const s = window.getComputedStyle(ele)[styleName];
  if (!s) return null;
  const t = /^(\d+)px$/.test(s);
  if (!t) return null;
  return parseInt(RegExp.$1, 10);
}



// WEBPACK FOOTER //
// ./src/directives/utils.js